'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
function objectToGetParams(object) {
  var params = Object.keys(object).filter(function (key) {
    return !!object[key];
  });
  if (!params.length) {
    return '';
  }
  return '?' + params.map(function (key) {
    return key + '=' + encodeURIComponent(object[key]);
  }).join('&');
}
exports.default = objectToGetParams;